import { render } from "./FAQEvalvation.vue?vue&type=template&id=3a934fa1"
import script from "./FAQEvalvation.vue?vue&type=script&lang=js"
export * from "./FAQEvalvation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__